import { ModalBody, ModalNext, useModal } from '@jutro/components';
import {useTranslator} from '@jutro/locale';
import { MetadataContent } from '@jutro/uiconfig';
import { useDependencies } from 'gw-portals-dependency-react';
import { ErrorCodes } from 'gw-portals-util-adac-js';
import React, { useCallback, useEffect, useRef, useState, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import AdacDocumentsUpload, { onDocumentsUpload } from '../../components/DocumentsUpload/AdacDocumentsUpload';
import usePortalModeBasedLabel from '../../hooks/usePortalModeBasedLabel';
import metadata from './AdacServiceConfirmationPage.metadata.json5';
import { CommunicationVariablesContext } from 'gw-capability-fnol-adac-react';
import styles from './AdacServiceConfirmationPage.module.scss';

function HtmlContent(props) {
    const elem = useRef(null);
    const { text } = props;
    useEffect(() => {
        elem.current.innerHTML = text;
    }, [text]);
    return (
        <p ref={elem}></p>
    );
}

function ServiceConfirmationPage({ history }) {
    const { ClaimService } = useDependencies('ClaimService');
    const [portalMessage, setPortalMessage] = useState(null);
    const { communicationVariables } = useContext(CommunicationVariablesContext)
    const { token, sessionUUID, communicationTypeExt } = communicationVariables;
    const [documentsSending, setDocumentsSending] = useState();
    const [documentsUploadVisible, setDocumentsUploadVisible] = useState();
    const [documentsToSend, updateDocumentsToSend] = useState([]);
    const outerCancel = useRef(null);
    const { showAlert } = useModal();
    const translator = useTranslator();

    useEffect(() => {
        if (!token || !sessionUUID) { return; }
        ClaimService.getPortalMessage(token, sessionUUID)
            .then((result) => setPortalMessage(result.body))
            .catch((error) => {
                if (error.appErrorCode === ErrorCodes.SESSION_EXPIRED) {
                    history.push({
                        pathname: '/sessionexpired'
                    });
                } else {
                    history.push('/callcenter');
                }
            });
    }, []);

    const viewDocuments = useCallback(() => {
        history.push({
            pathname: '/my-documents',
            state: {
                showHistoryTab: false
            }
        });
    }, []);

    const recall = useCallback(() => {
        history.push({
            pathname: '/recall'
        });
    }, [history, sessionUUID, token]);

    const sendNote = useCallback(() => {
        history.push({
            pathname: '/note'
        });
    }, [history, sessionUUID, token]);

    const redirectToHistoryTab = useCallback(() => {
        history.push({
            pathname: '/history'
        });
    }, [])

    const Modal = ({ children }) => {
        return (
            <ModalNext isOpen={documentsUploadVisible}>
                <ModalBody>
                    {children}
                </ModalBody>
            </ModalNext>
        );
    };

    const onSendDocuments = useCallback(async () => {
        onDocumentsUpload({
            documents: documentsToSend,
            ClaimService,
            updateDocumentsToSend,
            setDocumentsSent: () => {
                setDocumentsUploadVisible(false);
                updateDocumentsToSend([]);
                redirectToHistoryTab();
            },
            setDocumentsSending,
            translator,
            token,
            history,
            showAlert
        });
    }, [
        documentsToSend,
        ClaimService,
        updateDocumentsToSend,
        setDocumentsSending,
        setDocumentsUploadVisible,
        translator
    ]);

    const overrides = {
        pageHeaderTitle: {
            content: usePortalModeBasedLabel('pageHeaderTitle')
        },
        portalMessageContent: {
            text: portalMessage
        },
        documentsUploadContainer: {
            visible: documentsUploadVisible
        },
        documentsUploadSpinner: {
            loaded: !documentsSending
        },
        documentsUpload: {
            documentsToSend,
            updateDocumentsToSend,
            visible: !documentsSending,
            outerCancel
        },
        uploadOptionContainer: {
            onClick: () => setDocumentsUploadVisible(true),
        },
        cancelUploadButton: {
            onClick: () => {
                outerCancel.current();
                setDocumentsUploadVisible(false);
            },
            visible: !documentsSending
        },
        sendDocumentsButton: {
            visible: documentsToSend.length > 0 && !documentsSending,
            onClick: onSendDocuments,
        },
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            htmlcontent: HtmlContent,
            documentsupload: AdacDocumentsUpload,
            modal: Modal
        },
        resolveCallbackMap: {
            viewDocuments,
            recall,
            sendNote,
            redirectToHistoryTab
        }
    };
    return <MetadataContent
        uiProps={metadata.pageContent}
        overrideProps={overrides}
        {...resolvers}
    />;
}

export default withRouter(ServiceConfirmationPage);
